export default {"src":"/_next/static/media/thief_40.e5f116ed.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};